"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRequiredCookiesAndGetToken = void 0;
const fetchClient_1 = require("../utils/misc/fetchClient");
const index_1 = require("./index");
const constants_1 = require("../constants");
const generateRequiredCookiesAndGetToken = (platform) => __awaiter(void 0, void 0, void 0, function* () {
    const cookies = (0, index_1.parseCookies)();
    const authV2Cookies = cookies[constants_1.CookiesConstants.AUTH_V2];
    let authV2 = authV2Cookies ? (0, index_1.jsonSafeGet)(authV2Cookies) : undefined;
    if (!authV2) {
        // 2
        const authV1Cookies = cookies[constants_1.CookiesConstants.AUTH];
        const authV1 = authV1Cookies ? (0, index_1.jsonSafeGet)(authV1Cookies) : undefined;
        const deviceUUID = cookies[constants_1.CookiesConstants.DEVICE_UUID];
        if (authV1 && deviceUUID) {
            // 3 set Auth 2 cookie
            authV2 = {
                t: authV1.t,
                k: authV1.k,
                deviceUUID
            };
            (0, index_1.setCookie)(constants_1.CookiesConstants.AUTH_V2, JSON.stringify(authV2));
        }
        else {
            // 4 call register device
            authV2 = yield (0, fetchClient_1.__postAjaxClient)(`/register-device`, {
                platform: platform || (0, index_1.getQueryStringValue)('platform'),
                deviceUUID,
            });
            (0, index_1.setCookie)(constants_1.CookiesConstants.AUTH_V2, JSON.stringify(authV2));
            (0, index_1.setCookie)(constants_1.CookiesConstants.DEVICE_UUID, authV2.deviceUUID);
        }
        return authV2;
    }
    return authV2;
});
exports.generateRequiredCookiesAndGetToken = generateRequiredCookiesAndGetToken;
